import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e090fcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-12 flex justify-center" }
const _hoisted_2 = { class: "text-2xl font-bold mb-8 text-center" }
const _hoisted_3 = { class: "text-secondary text-center" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mt-12 flex justify-between" }
const _hoisted_6 = { class: "max-w-xs text-secondary whitespace-nowrap text-ellipsis overflow-x-hidden" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "max-w-xs text-secondary whitespace-nowrap text-ellipsis overflow-x-hidden" }

import { computed } from 'vue';
import { useMeta } from 'quasar';
import { useMetaStore } from 'stores/modules/meta';
import { useI18n } from 'vue-i18n';


import { useArticleStore } from 'stores/modules/article';

const __default__ = {
  async preFetch({ store, currentRoute, redirect }) {
    const articleStore = useArticleStore(store);
    await articleStore.fetch(currentRoute.params.id as string);
    if (!articleStore.article) {
      redirect('/404', 404);
    }
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DocumentPage',
  setup(__props) {

const { t, locale } = useI18n();

const articleStore = useArticleStore();
const article = computed(() => articleStore.article);

const metaStore = useMetaStore();
useMeta(
  Object.assign({}, metaStore.meta, {
    title: article.value?.title,
    titleTemplate: (title: string) => `${title} - ${metaStore.meta.title}`,
  })
);

const prevArticle = computed(() => articleStore.article?.prev);
const nextArticle = computed(() => articleStore.article?.next);

return (_ctx: any,_cache: any) => {
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "flex justify-center" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "p-12 bg-card" }, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(article.value?.title), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(article.value?.activeDate?.substring(0, 10)), 1),
            _createElementVNode("div", {
              class: _normalizeClass(`py-12 ql-editor ${_unref(locale)?.split('-')[0]}`),
              style: {"max-width":"1280px"},
              innerHTML: article.value?.content
            }, null, 10, _hoisted_4)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          (prevArticle.value)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                flat: "",
                "no-caps": "",
                href: `/news/${prevArticle.value.id}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('Document.previous')) + "：" + _toDisplayString(prevArticle.value.title), 1)
                ]),
                _: 1
              }, 8, ["href"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7)),
          (nextArticle.value)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 2,
                flat: "",
                "no-caps": "",
                href: `/news/${nextArticle.value.id}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('Document.next')) + "：" + _toDisplayString(nextArticle.value.title), 1)
                ]),
                _: 1
              }, 8, ["href"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})